class QuickCheckoutComponent extends HTMLElement {
  #abortController = new AbortController();

  connectedCallback() {
    const { signal } = this.#abortController;
    const scope = this.closest('.shopify-section, dialog, product-card');

    scope?.addEventListener('variant:update', this.#onVariantUpdate, { signal });
    this.querySelector('form')?.addEventListener('submit', this.#onBeforeSubmit, { signal });
  }

  disconnectedCallback() {
    this.#abortController.abort();
    this.#abortController = new AbortController();
  }

  /**
   * Keep the variant ID in sync and reflect availability on the button.
   * @param {CustomEvent} event
   */
  #onVariantUpdate = (event) => {
    const variant = event.detail?.resource;
    const variantInput = this.querySelector('input[name="id"]');
    const button = this.querySelector('button[type="submit"]');

    if (!variantInput || !button) return;

    variantInput.value = variant?.id ?? '';
    button.disabled = !(variant?.available ?? false);
  };

  /**
   * Before the native form submits, sync the variant ID and selling_plan from
   * the main product form — the authoritative source for whatever the user has
   * currently selected, including any subscription selling plan.
   */
  #onBeforeSubmit = () => {
    const scope = this.closest('.shopify-section, dialog, product-card');
    const mainForm = scope?.querySelector('form[data-type="add-to-cart-form"]');
    if (!mainForm) return;

    // Always read the freshest variant ID directly from the main form.
    const mainVariantId = mainForm.querySelector('[ref="variantId"]')?.value;
    const variantInput = this.querySelector('input[name="id"]');
    if (variantInput && mainVariantId) {
      variantInput.value = mainVariantId;
    }

    // Carry any selling_plan (native subscriptions) through to checkout.
    const sellingPlanValue = mainForm.querySelector('input[name="selling_plan"]')?.value ?? '';
    const sellingPlanInput = this.querySelector('input[name="selling_plan"]');
    if (sellingPlanInput) {
      sellingPlanInput.value = sellingPlanValue;
      sellingPlanInput.disabled = !sellingPlanValue;
    }
  };
}

if (!customElements.get('quick-checkout-component')) {
  customElements.define('quick-checkout-component', QuickCheckoutComponent);
}
